module.exports = __webpack_public_path__ + "img/centro.16e505f0.jpg";